import React from "react";

import Ouvidoria from "../../components/Ouvidoria";
import './ouvidoria.scss';

import TitleAbout from "../../components/Title";

// icons images
import sugestion from './img/sugestao.png';
import compliments from './img/gostar.png';
import reclamations from './img/reclamacao.png';
import doubts from './img/questao.png';
import atendimento from './img/ouvidoria.png';
import SEO from "../../SEO/SEO";

export default function Ombudsman() {

  return (
    <>
      <SEO title="Ouvidoria - Séculos Engenharia e Serviços LTDA" link='https://seculosengenharia.com.br/ouvidoria' />
      <TitleAbout name="Ouvidoria" link1={"Home/ "} link2={"Ouvidoria"} />

      <section id='Ombudsman'>
        <div className='Ombudsman container'>
          <div className='desc-Ombudsman'
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
            data-aos-offset="0">
            <h3>Bem-vindo ao nosso canal de  ouvidoria</h3>
              <p>Para esclarecimentos de dúvidas procure a sua liderança imediata. As
                denúncias poderão ser feitas para o Comitê de Conduta e Ética através do
                telefone <strong>(94) 99901-2631</strong> ou pelo e-mail <strong><a href="mailto:ouvidoria@seculosengenharia.com.br" >ouvidoria@gruposeculos.com.br</a></strong> a denúncia poderá ser anônima. Lembrando que, sendo anônima, o Comitê
                não poderá dar retorno ao denunciante.
                <br/>
                <br/>
                Se a denúncia tiver identificação, o Comitê garantirá o sigilo do informante.
                Havendo necessidade, caberá ao Comitê de Conduta e Ética tomar os
                depoimentos das partes envolvidas, examinar a documentação e o que mais
                for necessário e, com base nos fatos apurados, determinar se houve ou não a
                violação desse Código. Em caso afirmativo, determinar as sanções a serem
                aplicadas.
            </p>
          </div>
          <div className='Ombudsman'>
            <picture className='desc-Ombudsman'
              data-aos="fade-zoom-in"
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offset="0">
                <img src={atendimento} width={350} alt="Ouvidoria - Séculos Engenharia e Serviços" />              
            </picture>
          </div>
        </div>
      </section>

      <section id="formsOmbudsman">
        <div className="formsOmbudsman container">
          <div>
            {/* <h2
              data-aos-delay="300"
              data-aos-offset="0">Venha fazer parte do nosso time!</h2> */}
          </div>
          <div className="formsContainerBox">
            <div className="formsWorkBox">
              <div className="formsSmallBox">
                <div className='box' 
                  data-aos-delay="300"
                  data-aos-offse="0">
                    <div className="img-icon">
                      <img src={sugestion} alt="Ouvidoria - Seculos Engenharia e Serviços"/>
                    </div>
                    <div>
                      <h2>sugestões</h2>
                      <p>Este é o espaço para você propor melhorias ou novas ideias que possam contribuir para o aprimoramento dos nossos serviços.</p>
                    </div>
                </div>
                <div className='box' 
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <div className="img-icon">
                    <img src={compliments} alt="Ouvidoria - Seculos Engenharia e Serviços" />
                  </div>
                  <div>
                    <h2>elogios</h2>
                    <p>Reconheça e valorize os serviços ou atendimentos que você considerou excelentes.</p>
                  </div>
                </div>
                <div className='box' 
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <div className="img-icon">
                    <img src={reclamations} alt="Ouvidoria - Seculos Engenharia e Serviços" />
                  </div>
                  <div>
                    <h2>reclamações</h2>
                    <p>Use este canal para relatar problemas, insatisfações ou irregularidades que você tenha encontrado.</p>
                  </div>
                </div>
                <div className='box' 
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <div className="img-icon">
                    <img src={doubts} alt="Ouvidoria - Seculos Engenharia e Serviços"/>
                  </div>
                  <div>
                    <h2>dúvidas</h2>
                    <p>Se você tem dúvidas sobre nossos serviços, procedimentos ou qualquer outra informação, este é o lugar para esclarecê-las.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="button_box">
            <button className="button_cv">
              <a href="https://seculosengenharia.com.br/ouvidoria-seculos/" target="blank">ABRIR MEU MANIFESTO</a>
            </button>
          </div>
        </div>
      </section>
      <Ouvidoria />
    </>
  );
}
